import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import axiosRestaurantInstance from './AxiosRestaurantInstance';

import './css/OrderDetails.css';


const OrderDetails = () => {
    const { orderId, restaurantId } = useParams();
    const [orderDetails, setOrderDetails] = useState(null);
    const [orderItems, setOrderItems] = useState([]);
    const [paymentDetails, setPaymentDetails] = useState({});

    useEffect(() => {
        const token = localStorage.getItem('Token')
        const fetchOrderDetails = async () => {
            try {
                const response = await axiosRestaurantInstance.get(`/get_orders_all/${restaurantId}`,{
                    headers: {
                        'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
                    }
                });
                const data = response.data;
                console.log("Fetched orders data:", data);

                // Find the specific order by ID
                const order = data.orders?.find(o => o.orderId === Number(orderId));

                if (order) {
                    setOrderDetails(order);
                    setOrderItems(order.OrderLineItems || []);
                    setPaymentDetails(order.Payment || {});
                } else {
                    console.error(`Order with ID ${orderId} not found`);
                    setOrderDetails({});
                }
            } catch (error) {
                console.error('Error fetching order details:', error);
            }
        };

        fetchOrderDetails();
    }, [orderId, restaurantId]);

    if (!orderDetails) {
        return <div>Loading order details...</div>;
    }

    return (
        <div className="order-details">
            <h1>Order Details for Order ID: {orderId}</h1>

            <h2>Order Information</h2>
            <table>
                <tbody>
                    <tr>
                        <td>Customer Name:</td>
                        <td>{orderDetails.customerName || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Total Price:</td>
                        <td>{orderDetails.totalPrice || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Order Status:</td>
                        <td>{orderDetails.orderStatus || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Created Date:</td>
                        <td>{orderDetails.createdDate || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>organization ID:</td>
                        <td>{orderDetails.organizationId || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>organization Name:</td>
                        <td>Organization ID:</td>
                        <td>{orderDetails.organizationId || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Organization Name:</td>
                        <td>{orderDetails.organizationName || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Receiver Name:</td>
                        <td>{orderDetails.receiverName || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Child Name:</td>
                        <td>{orderDetails.childName || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Notes:</td>
                        <td>{orderDetails.notes || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Delivery Contact Name:</td>
                        <td>{orderDetails.deliveryContactName || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Delivery Contact Number:</td>
                        <td>{orderDetails.deliveryContactNumber || 'N/A'}</td>
                    </tr>
                </tbody>
            </table>

            <h2>Order Items</h2>
            <table>
                <thead>
                    <tr>
                        <th>Food Item</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>GST</th>
                        <th>Service Tax</th>
                        <th>Convenience Fee</th>
                        <th>Delivery Fee</th>
                    </tr>
                </thead>
                <tbody>
                    {orderItems.length > 0 ? (
                        orderItems.map(item => (
                            <tr key={item.orderLineId}>
                                <td>{item.foodItemName}</td>
                                <td>{item.foodQuantity}</td>
                                <td>{item.price}</td>
                                <td>{item.GST}</td>
                                <td>{item.serviceTax}</td>
                                <td>{item.convienceFee}</td>
                                <td>{item.deliveryFee}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7">No items found for this order.</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <h2>Payment Details</h2>
            <table>
                <thead>
                    <tr>
                        <th>Transaction ID</th>
                        <th>Payment Status</th>
                        <th>Amount</th>
                        <th>Bank RRN</th>
                        <th>Customer Details</th>
                    </tr>
                </thead>
                <tbody>
                    {paymentDetails ? (
                        <tr>
                            <td>{paymentDetails.transactionId || 'N/A'}</td>
                            <td>{paymentDetails.status || 'N/A'}</td>
                            <td>{paymentDetails.amount || 'N/A'}</td>
                            <td>{paymentDetails.bankRRN || 'N/A'}</td>
                            <td>{paymentDetails.customerDetails || 'N/A'}</td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan="5">No payment details available.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default OrderDetails;
